require("./bootstrap");

require("./assets/css/bootstrap.min.css");
require("./assets/scss/paper-dashboard.scss");
require("./assets/js/core/bootstrap.min.js");
require("./assets/js/plugins/perfect-scrollbar.jquery.min.js");
require("./assets/js/paper-dashboard.js");
require("./assets/js/plugins/bootstrap-switch.js");

import Vue from "vue";
import App from "./App.vue";

import PaperDashboard from "./plugins/paperDashboard";
Vue.use(PaperDashboard);

import LiquorTree from "liquor-tree";
Vue.use(LiquorTree);

import VModal from "vue-js-modal";
Vue.use(VModal, { dialog: true, injectModalsContainer: true });

import VueI18n from "vue-i18n";
Vue.use(VueI18n);

import PerfectScrollbar from "vue2-perfect-scrollbar";
import "vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css";
Vue.use(PerfectScrollbar);

import Notifications from "vue-notification";
Vue.use(Notifications);

// import vue-panzoom
import panZoom from "vue-panzoom";
Vue.use(panZoom);

Vue.config.productionTip = false;

import router from "./router/index.js";
import store from "./store";

const messages = require("./locales.json");
const i18n = new VueI18n({
  locale: "en", //document.documentElement.lang,
  messages,
});

Vue.mixin({
  methods: {
    showNotification(gr, title, message, classCSS) {
      this.$notify({
        group: gr,
        title: title,
        text: message,
        type: classCSS,
        duration: 8000,
      });
    },
    isValid(some) {
      if (
        some != null &&
        some != undefined &&
        some != "" &&
        typeof some != "undefined"
      ) {
        return true;
      } else {
        return false;
      }
    },
    changeLanguage(lang) {
      //this.$$refs.lang_btn.
      localStorage.setItem("lang", lang);
      this.$i18n.locale = lang;
      //console.log(lang);
    },
    makeQuery: function (stringQuery, jsonData) {
      this.$store.state.isLoading = true;
      this.$store.state.queries.push(true);

      return new Promise((resolve, reject) => {
        axios
          .post(stringQuery, jsonData)
          .then((response) => {
            this.$store.state.queries.splice(0, 1);
            if (this.$store.state.queries.length < 1) {
              this.$store.state.isLoading = false;
            }

            if (response.status == 200) {
              if (
                typeof response.data == "string" &&
                response.data != "true" &&
                response.data != "Истина"
              ) {
                console.log(response.data);
                this.showNotification("error", "Error", response.data);
              } else {
                return resolve(response);
              }
            } else {
              return reject(response);
            }
            if (response.status == 200) {
              if (typeof response.data == "string") {
                if (response.data == "Истина") {
                  return resolve(response);
                } else {
                  console.log(response.data);
                  this.showNotification("error", "Error", response.data);
                }
              } else {
                return resolve(response);
              }
            } else {
              this.showNotification("error", "Error", response.data);
              console.log(
                "Something wrong but there is no error, status != 200"
              );
              return reject(response.data);
            }
          })
          .catch((error) => {
            this.$store.state.queries.splice(0, 1);
            if (this.$store.state.queries.length < 1) {
              this.$store.state.isLoading = false;
            }

            //this.showNotification("error", "Error", error);

            if (
              error &&
              error.response &&
              error.response.status &&
              (error.response.status == 500 || error.response.status == 401)
            ) {
              localStorage.removeItem("user-token");
              localStorage.removeItem("ip");
              localStorage.removeItem("name");
              localStorage.removeItem("role");
              localStorage.removeItem("user");
              this.$router.push({ name: "login" });
              this.showNotification("error", "Error", this.$t("errors.500"));
            } else {
              this.showNotification(
                "error",
                "Error",
                "Contact IT department, server response failed"
              );
              console.log("Query error: ", error);
            }
            return reject(error);
          });
      });
    },
  },
});

new Vue({
  router,
  el: "#app",
  render: (h) => h(App),
  store,
  i18n,
  created: function () {
    if (this.$route.path != "/displaydraw") {
      console.log("axios.interceptors.response.use");
      axios.interceptors.response.use(undefined, function (err) {
        return new Promise(function (resolve, reject) {
          if (err.response && err.response.status !== 200) {
            localStorage.removeItem("user-token");
            localStorage.removeItem("ip");
            localStorage.removeItem("name");
            localStorage.removeItem("role");
            localStorage.removeItem("user");
            router.push("/");
          }
          throw err;
        });
      });
      //this.$store.dispatch("loadAuthUser").then(user => {

      // router.push('/dashboard/main')

      // if (localStorage.getItem('user-token') != null) {
      //   this.$emit('loggedIn')
      //   console.log(this.$route.params)
      //   console.log(this.$route.params.nextUrl)
      //   if (this.$route.params.nextUrl != null) {
      //     //this.loading = false;
      //     this.$router.push(this.$route.params.nextUrl)
      //   } else {
      //     // this.loading = false;
      //     this.$router.push('dashboard')
      //   }
      // }
      //}).catch(e => {
      //  console.log(e)
      //});
    }
  },
  methods: {
    changeLanguage(lang) {
      this.$i18n.locale = lang;
    },
    showNotify(group, title, messages) {
      this.$notify({
        group: group,
        title: title,
        text: messages,
      });
    },
  },
});



// WEBPACK FOOTER //
// ./src/main.js